<app-widget-base [title]="title">
  <div class="pyramid-content" [class.highlightMode]="highlight.length">
    <ng-container *ngIf="!comparisonData">
      <div
        *ngFor="let elem of referenceData; let index = index"
        class="elem"
        [class.highlight]="highlight.indexOf(elem.id) !== -1"
      >
        <div class="popup">
          <h5>
            {{ 'Range' | translate }}
            <span>{{ elem.category | translate }}</span>
          </h5>
          <p class="value">
            {{
              isNumber(elem.value)
                ? (elem.value | hideZeroValues : '1.0-0')
                : elem.value
            }}
            <span>{{ unit }}</span>
          </p>
          <p
            class="value"
            *ngIf="
              isVisitsAvailable && stats && getPercentageTotalValue(elem) !== 0
            "
          >
            {{
              getPercentageTotalValue(elem) | hideZeroValues : '1.0-1'
            }}%&nbsp;<span
              >{{ 'over the total of' | translate }}&nbsp;{{ unit }}</span
            >
          </p>
        </div>
        <div class="elem-inner">
          <p class="label">
            {{ elem.category | translate }}
            <span class="value">{{
              elem.perc !== '--'
                ? (elem.perc | hideZeroValues : '1.1-1')
                : elem.perc
            }}</span>
          </p>
          <div class="progressbar">
            <div [style.width]="elem.perc + '%'"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="comparisonData">
      <div class="labels">
        <span title="{{ labels[0] }}">{{ labels[0] }}</span>
        <span title="{{ labels[1] }}">{{ labels[1] }}</span>
      </div>
      <div
        *ngFor="let elem of referenceData; let index = index"
        class="elem withComparison"
        [class.highlight]="highlight.indexOf(elem.id) !== -1"
        [style.background-image]="getBackground(index)"
        [style.height.px]="20"
      >
        <div class="popup">
          <h5>
            {{ 'Range' | translate }}
            <span>{{ elem.category | translate }}</span>
          </h5>
          <p class="value">
            {{ elem.value | hideZeroValues : '1.0-0' }}
            <span>{{ unit }} ({{ 'Reference' | translate }})</span>
          </p>
          <p class="value compared">
            {{ comparisonData[index].value | hideZeroValues : '1.0-0' }}
            <span>{{ unit }} ({{ 'Compared' | translate }})</span>
          </p>
        </div>
        <span>{{ elem.perc | hideZeroValues : '1.1-1' }}</span>
        <span class="center">{{ elem.category | translate }}</span>
        <span>{{ comparisonData[index].perc | hideZeroValues : '1.1-1' }}</span>
      </div>
    </ng-container>
    <p class="legend">{{ description }}</p>
  </div>
</app-widget-base>
